import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import ShowIfAllowed from '../../../../components/common/show-if-allowed';
import { ActiveFilter } from '../../../../components/common/table/active-filter';
import Table from '../../../../components/common/table/table';
import Title from '../../../../components/common/title';
import { LinkComponent as Link } from '../../../../components/form/elements/link';
import Partner from '../../../../interfaces/partner';
import {
  HUMAN_PARTNERS_CREATE,
  HUMAN_PARTNERS_VIEW,
} from '../../../../router/routes';
import { useService } from '../../../../services/services';
import { route } from '../../../../services/utils';
import css from './index.module.css';

export default function Partners() {
  const { t } = useTranslation();
  const { farmId } = useParams<{ farmId: string }>();
  const { partnerService } = useService();

  const request = useCallback(
    (page: number, sort: string, desc: boolean, filter: any) =>
      partnerService.index(farmId, { page, sort, desc, ...filter }),
    [partnerService, farmId]
  );

  return (
    <div className={css['index']}>
      <Title title={t('pages.human.partners.partners')} />
      <div className={css['body']}>
        <ShowIfAllowed ability={{ title: 'create partner' }}>
          <div className={css['toolbar']}>
            <div className={css['left']}>
              <div>
                <Link
                  label="add"
                  primary={true}
                  linkTo={route(HUMAN_PARTNERS_CREATE, { farmId })}
                  icon={faPlus}
                />
              </div>
            </div>
          </div>
        </ShowIfAllowed>
        <Table<Partner>
          request={request}
          keyAccessor="id"
          columns={[
            {
              accessor: 'form_of_economic_activity_value',
              header: t('classifiers.form_of_economic_activity'),
              sortable: true,
              className: css['strong'],
            },
            {
              accessor: 'name',
              header: t('name'),
              sortable: true,
              className: css['strong'],
            },
            {
              accessor: 'registration_number',
              header: t('registration_number'),
            },
            { accessor: 'contact_person', header: t('contact_person') },
            { accessor: 'contact_phone', header: t('contact_phone') },
            {
              accessor: 'active',
              header: t('active'),
              filter: <ActiveFilter />,
            },
          ]}
          viewRoute={route(HUMAN_PARTNERS_VIEW, { farmId })}
          viewRecordAbility={{ title: 'view partner' }}
        />
      </div>
    </div>
  );
}
